import * as React from "react";

const Returns: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd">
                <g fill="#002856" fillRule="nonzero">
                    <g>
                        <path
                            d="M74.147 36c-.349.031-.669.276-.794.603l-3.294 8.956c-.039.103-.059.213-.059.323v5.177c-.007.496.443.954.941.954.499 0 .949-.458.942-.954v-4.236h28.235v19.295H71.883v-9.412h11.764v2.353c.002.667.875 1.149 1.441.794l5.177-3.294c.531-.338.531-1.25 0-1.588l-5.177-3.295c-.183-.12-.413-.174-.632-.147-.447.065-.813.49-.809.942v2.352H70.941c-.492 0-.94.449-.94.942v11.294c0 .492.448.941.94.941h30.118c.492 0 .941-.449.941-.941V45.882c0-.079-.01-.158-.03-.235l-2.352-8.956c-.109-.395-.502-.693-.912-.691h-24.56.001zm.75 1.882h9.691v7.06H72.294l2.603-7.06zm11.574 0h11.515l1.853 7.06H86.47v-7.06zm-.941 16.295l2.485 1.588-2.485 1.588v-3.176z"
                            transform="translate(-643 -576) translate(573 540) matrix(-1 0 0 1 172 0)"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Returns);
